import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EmaFirmUserSearchService {
    private http = inject(HttpClient);

    private baseUrl = environment.apiUrl + '/api/v1/ema-firm-user/';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    search(searchTerm: string, pod: string | undefined, firmId: number | undefined, excludedEmaUserIds? : number []): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        let params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('page', 0)
            .set('size', 5);
        if (excludedEmaUserIds && excludedEmaUserIds.length) {
            params = params.set(
                'excludedFirmUserIds',
                excludedEmaUserIds.join(',')
            );
        }
        return this.http.get(`${this.baseUrl}pod/${pod}/firm/${firmId}/search`, { headers, params });
    }
}
